import { app } from '@/main';
import TwismWallet from '@/views/Admin/TwismWallet/TwismWallet.vue';
import flagKeys from '@/constants/flagKeys';
import { Route } from '../route.model';

const validateRouteFlag = () => {
  return (
    app.$store.getters['manager/hasTwismWalletAccess'] &&
    app.$store.getters['flags/getFlags'].includes(flagKeys.twismWalletV1)
  );
};

const adminTwismWallet = new Route(
  '/admin/twism-wallet',
  'twism_wallet',
  TwismWallet,
  {
    requiresAuth: true,
    superRoot: true,
    navbar: {
      name: 'Twism Wallet', // TODO apply i18n
      icon: 'coin-rewarded'
    },
    customFlagValidator: validateRouteFlag,
    zendesk: {
      disabled: true
    }
  }
);

export { adminTwismWallet };
export default adminTwismWallet;
